(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace-competition/route-result/assets/javascripts/highscore/highscore-search.js') >= 0) return;  svs.modules.push('/components/marketplace-competition/route-result/assets/javascripts/highscore/highscore-search.js');
"use strict";


const {
  useContext,
  useEffect,
  useRef,
  useCallback,
  useState
} = React;
const {
  useSelector
} = ReactRedux;
const {
  ReactIcon
} = svs.ui;
const {
  ControlGroup,
  Inputv2
} = svs.ui.reactForm;
const {
  HighscoreContext
} = svs.components.marketplaceCompetition.routeResult.highscore;
const {
  selectCompetitionResultPending
} = svs.components.marketplaceCompetition.services.selectors.competitionResultSelectors;
const HighscoreSearch = _ref => {
  let {
    description,
    minLength = 3,
    debounce = 500,
    competitionId
  } = _ref;
  const {
    setSearchTerm,
    searchTerm = '',
    type,
    setOffset
  } = useContext(HighscoreContext);
  const listIsPending = useSelector(state => selectCompetitionResultPending(state, competitionId, type));
  const [searchterm, setSearchterm] = useState(searchTerm);
  const lastSearchLength = useRef(searchTerm.length);
  const onSearchChange = useCallback(e => {
    setSearchterm(e.currentTarget.value);
    setOffset(0);
  }, [setOffset]);
  useEffect(() => {
    const searchTermLength = searchterm.length;
    const triggerSearch = () => {
      if (searchTermLength >= minLength && !listIsPending) {
        lastSearchLength.current = searchTermLength;
        setSearchTerm(searchterm);
        setOffset(0);
      }
    };
    const triggerClear = () => {
      lastSearchLength.current = searchTermLength;
      setSearchTerm('');
      setOffset(0);
    };
    const debounceTimer = setTimeout(() => {
      triggerSearch();
    }, debounce);
    if (searchTermLength === 0 && lastSearchLength.current > 0) {
      clearTimeout(debounceTimer);
      triggerClear();
    }
    return () => {
      clearTimeout(debounceTimer);
    };
  }, [searchTerm, debounce, minLength, setSearchTerm, searchterm, listIsPending, setOffset]);
  return React.createElement(ControlGroup, {
    v2: true
  }, React.createElement(Inputv2, {
    id: "reactAmount",
    inputHelpText: description,
    label: description,
    onChange: onSearchChange,
    suffix: React.createElement(ReactIcon, {
      icon: "search",
      size: "100"
    }),
    value: searchterm
  }));
};
HighscoreSearch.PropType = {
  description: PropTypes.string,
  minLength: PropTypes.number,
  debounce: PropTypes.number,
  competitionId: PropTypes.number
};
setGlobal('svs.components.marketplaceCompetition.routeResult.highscore.HighscoreSearch', HighscoreSearch);

 })(window);